import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService} from "../../shared/services/dataService"
import { CaseService } from '../../shared/services/caseService';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Inject, ViewChild, ElementRef } from '@angular/core';

import * as _ from 'lodash';
import * as moment from 'moment';
import { MatSelect } from '@angular/material/select';
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';

let jsPDF = require('jspdf');

@Component({
    selector: 'case-report',
    templateUrl: './caseReport.html',
    styleUrls: ['./caseReport.component.css']
})
export class CaseReportComponent  implements OnInit {
  @ViewChild(MatSelect) matSelect : MatSelect;
  type: string;
  title: string;
  archivalResult: string;
  archivalResultStatus: string;
  caseReportForm: FormGroup;
  public items:any;
 
  private value:any = ['Athens'];
  private _disabledV:string = '0';
  private disabled:boolean = false;
  loadingCount: number = 0;
  public statuses: Array<string> = ['Select All', 'Open', 'Available', 'Submitted', 'Dismissed'];
  public mannerOfDeath: Array<string> = ["Select All", "Undetermined", "Accident", "Suicide", "Natural", "Homicide", "Pending"];
  public template;
  public lastTab;
  public tabs;
  public groups: any;
  public groupsSelected: any ='';

  date: Date;

  constructor(
    private dataService: DataService,
    private caseService:CaseService,
    private formBuilder : FormBuilder,
    private dialogRef: MatDialogRef<CaseReportComponent>,
    @Inject(MAT_DIALOG_DATA) public caseReportInput: CaseReportInput
  ) {
      this.date = new Date();
      this.caseReportForm = this.formBuilder.group({
                    "startDateDeath" : ["",  Validators.nullValidator] ,
                    "endDateDeath" : [new Date(),  Validators.required],
                    "startDateReview" : ["", Validators.nullValidator],
                    "endDateReview" : [new Date(),  Validators.required],
                    "format":["csv",  Validators.required],
                    "jurisdiction" : ["County 1", Validators.nullValidator],
                    "status" : ["Select All", Validators.nullValidator],
                    "mannerOfDeath" : ["Select All", Validators.nullValidator], //Manner of Death,
                    "groups":[""],
                    "fatal": [false, Validators.nullValidator],
                    "nonFatal":[false, Validators.nullValidator],
                    "isArchived": [false, Validators.nullValidator]
      });

      this.type = caseReportInput.type;
      this.title = caseReportInput.title;
  }

  public itemsToString(value:Array<any> = []):string {
    return value
      .map((item:any) => {
        return item.text;
      }).join(',');
  }

  ngOnInit() {
    this.dataService.getTemplate().then(template=>{
      this.template = template;
      this.tabs = _.map( _.uniqBy(this.template.Groups,'Tab'),'Tab');
      this.groups =  _.map(_.orderBy(this.template.Groups,['Tab']), group=>{
        return {'name' : group.Name, 'tab': group.Tab}; });
    });
  }

  ngAfterViewInit(): void {
    // There's a weird bug where the MatSelect dialog does not
    // close when clicked outside of it within the modal dialog.
    // This force closes the dialog when clicked outside the matselect
    // panel.
    if(this.matSelect) {
      this.matSelect.openedChange.subscribe(opened => {
        if (opened) {
          document.onclick = (args: any) : void => {
            if(!this.isParentPanel(args.target)) {
              this.matSelect.close();
            }
          }
        } else {
          document.onclick = _ => {};
        }
      })
    }
  }

  isParentPanel(element : any) {
    if(element == undefined) return false;
    if(this.matSelect && this.matSelect.panel && element === this.matSelect.panel.nativeElement) return true;
    if(element.parentElement) {
      return this.isParentPanel(element.parentElement);
    }
    return false;
  }

  showTab(tab){
    const show =this.lastTab !== tab;
    this.lastTab = tab;
    return show;
  }

  getGroups(tab: string){
    return _.filter(this.template.Groups,{'Tab':tab});
  }

  onNgModelChange(event){
    console.log('on ng model change', event);
  }

  archiveCases(archive: boolean) {
    var caseReportForm = this.caseReportForm.value;
    this.loadingCount++;
    var selectedStatus = '';

    if (caseReportForm.status != "Select All") {
      if (caseReportForm.status == "Open") {
        selectedStatus = "Assigned"; //Open case is mapped to 'Assigned'
      }
      else {
        selectedStatus = caseReportForm.status;
      }
    }

    var input = {
      caseStatus: selectedStatus ?? null,
      fatal: caseReportForm.fatal ?? null,
      nonFatal: caseReportForm.nonFatal ?? null,
      archive: archive,
    }

    for (var key in input) {
      if (!input[key]) {
        delete input[key];
      }
    }
    if (caseReportForm.startDateDeath) {
      var dateDeath = {
        startDateDeath: caseReportForm.startDateDeath ?? null,
        endDateDeath: caseReportForm.endDateDeath ?? null,
      }
      input = {
        ...input,
        ...dateDeath
      }
    }
    if (caseReportForm.startDateReview) {
      var dateReview = {
        startDateReview: caseReportForm.startDateReview ?? null,
        endDateReview: caseReportForm.endDateReview ?? null,
      }
      input = {
        ...input,
        ...dateReview
      }
    }

    this.caseService.ArchiveCases(input).then(res => {
      this.archivalResult = res["Result"];
      this.archivalResultStatus = 'success';
      this.loadingCount--;
      EventAggregator.publish(EventList.refreshDashboard, true);
    }).catch(err => {
      this.archivalResultStatus = 'error';
      this.loadingCount--;
      console.log(err);
    })
  }

  downloadCSV(caseReportForm  :any){
    if (this.type == 'ARCHIVE') {
      return;
    }
    this.loadingCount ++;
    var selectedStatus = '';

    if (caseReportForm.status != "Select All") {   
      if (caseReportForm.status == "Open") {
        selectedStatus = "Assigned"; //Open case is mapped to 'Assigned'
      }
      else{
        selectedStatus = caseReportForm.status;
      }
    }

    var selectedMOD = ''; 
    if (caseReportForm.mannerOfDeath != "Select All"){
    
      selectedMOD = caseReportForm.mannerOfDeath;
    }
  
    let localType = this.type; //.then needs context to this variable
    const selected = this.groupsSelected ? this.groupsSelected: '';
    this.caseService.DownloadCases(
        caseReportForm.startDateDeath, 
        caseReportForm.endDateDeath, 
        caseReportForm.startDateReview, 
        caseReportForm.endDateReview,
        selectedStatus, selectedMOD,
        this.type, selected, caseReportForm.fatal,
        caseReportForm.nonFatal,
        caseReportForm.isArchived
      )
      .then(function(contents) {
        let blob = new Blob([contents]);
        let downloadName = (localType === 'OCME') ? 'decendent' : 'case';
        downloadName += caseReportForm.isArchived ? '_archived' : '';
        let filename = 'ofr_' + downloadName + moment().format('YYYYMMDD') + '.csv';
        
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, filename);
        } 
        else {
        let csvUrl = window.URL.createObjectURL(blob);

        let arc = document.createElement('a');
        arc.id = "lnkDwnldLnk";
        arc.setAttribute('download', filename);
        arc.setAttribute('href', csvUrl);
        arc.click();
        document.body.appendChild(arc);
        }
        this.loadingCount --;
      })
      .catch(() => {
        this.loadingCount --;
      });
  }

  onCloseModal(event: any){
    this.dialogRef.close();
  }

//<table style=width:100%><tr><th>Firstname</th><th>Lastname</th> <th>Age</th></tr><tr><td>Jill</td><td>Smith</td> <td>50</td></tr><tr><td>Eve</td><td>Jackson</td> <td>94</td> </tr></table>
  downloadPDF() {
    var doc = new jsPDF();
    var i=0;

    for(var key in this.items){
      doc.text(20, 10 + i, "test: " + key);
      i+=10;
    }

    doc.save('Test.pdf');
  }
}

interface CaseReportInput {
  type: string;
  title: string;
}